import React from 'react';
import { get } from 'lodash';
import { alphabetizeBy } from '@ion/mrdash';
import PipelineIntegrationMenuItem from './PipelineIntegrationMenuItem';

export default function buildPipelineIntegrationOptions(pipelineIntegrations) {
  const alphabetizedIntegrations = alphabetizeBy(pipelineIntegrations, pipelineIntegration =>
    get(pipelineIntegration, 'integration.name')
  );
  return alphabetizedIntegrations.map(pipelineIntegration => ({
    value: pipelineIntegration.id,
    label: <PipelineIntegrationMenuItem pipelineIntegration={pipelineIntegration} />,
  }));
}
